export class VarianceReasonRecord {
    id: number;
    shiftBlockId: number;
    shiftRecordId?: number;
    workflowTimeFacility: string;
    varianceReasonId: number;
    explanation: string;
    modifiedByUserName: string;
    modifiedDate: Date;

    // used during editing process not saved to db
    editing: boolean;
}